import ListItem from "./listItem";
import { AppValue } from "../../../contexts/app";
import { useContext, useEffect, useState } from "react";

export default function  Roles({ open, active, onClick }) {
  const [roles, setRoles] = useState(null);
  const context = useContext(AppValue);

  useEffect(() => {
    if (!!context.roles) {
      const r = context.roles;
      const sortedRoles = Object.keys(r)
        .sort((a, b) => {
          let nameA = r[a].toUpperCase();
          let nameB = r[b].toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        })
        .map(cur => {
          return {
            id: cur,
            name: r[cur]
          }
        });
      setRoles(sortedRoles);
    }
  }, [context]);

  if (!open) return null;
  return (
    <div>
      {(roles || []).map((role, i) => (
        <ListItem
          key={role.id}
          index={role.id}
          title={role.name}
          active={active === role.id}
          onClick={onClick}
        />
      ))}
    </div>
  )
}